import { Component, Section, ComponentsData } from '../../types/Components';
import { LocalSection } from '../../service/components/types';

export const SET_COMPONENTS = '@COMPONENTS/SET_COMPONENTS';
export const SET_IS_LOADING = '@COMPONENTS/SET_IS_LOADING';
export const GET_COMPONENTS = '@COMPONENTS/GET_COMPONENTS';
export const ADD_DIGITALLY_RECEIVED = '@ADD_DIGITALLY_RECEIVED';
export const SET_ERROR = '@COMPONENTS/SET_ERROR';
export const SET_COMPONENT = '@COMPONENTS/SET_COMPONENT';
export const SET_COMPONENT_SECTION = '@COMPONENTS/SET_COMPONENT_SECTION';
export const SET_FETCHED_COMPONENT = '@COMPONENTS/SET_FETCHED_COMPONENT';
export const DELETE_SERIES_SUBMISSION_WINDOW = '@COMPONENTS/DELETE_SERIES_SUBMISSION_WINDOW';
export const DELETE_SECTION = '@COMPONENTS/DELETE_SECTION';
export const DELETE_COMPONENT_SECTION = '@COMPONENTS/DELETE_COMPONENT_SECTION';
export const DELETE_COMPONENT_SECTIONS = '@COMPONENTS/DELETE_COMPONENT_SECTIONS';
export const DELETE_ALL_SECTIONS = '@COMPONENTS/DELETE_ALL_SECTIONS';
export const DELETE_ALL_COMPONENTS = '@COMPONENTS/DELETE_ALL_COMPONENTS';
export const SET_IS_REPORT_BEING_GENERATED = '@COMPONENTS/SET_IS_REPORT_BEING_GENERATED';

export interface SetComponents {
  type: typeof SET_COMPONENTS;
  payload: {
    components: ComponentsData;
  };
}

export interface SetIsLoading {
  type: typeof SET_IS_LOADING;
  payload: { value: boolean };
}

export interface GetComponents {
  type: typeof GET_COMPONENTS;
}

export interface SetComponent {
  type: typeof SET_COMPONENT;
  payload: {
    componentId: Component['_id'];
    component: Component;
  };
}
export interface SetFetchedComponent {
  type: typeof SET_FETCHED_COMPONENT;
  payload: {
    component?: Component;
  };
}

export interface SetComponentSection {
  type: typeof SET_COMPONENT_SECTION;
  payload: {
    componentId: Component['_id'];
    component: Component;
  };
}

export interface AddDigitallyReceived {
  type: typeof ADD_DIGITALLY_RECEIVED;
  payload: {
    componentId: Component['_id'];
    sectionData: Section | LocalSection;
  };
}

export interface DeleteSection {
  type: typeof DELETE_SECTION;
  payload: {
    componentId: Component['_id'];
    id: number;
  };
}

export interface DeleteComponentSection {
  type: typeof DELETE_COMPONENT_SECTION;
  payload: {
    componentId: Component['_id'];
    id: number;
  };
}

export interface DeleteComponentSections {
  type: typeof DELETE_COMPONENT_SECTIONS;
  payload: {
    componentId: Component['_id'];
  };
}

export interface DeleteSeriesSubmissionWindow {
  type: typeof DELETE_SERIES_SUBMISSION_WINDOW;
  payload: {
    componentId: Component['_id'];
    id: number;
    field: 'submissionWindow' | 'marksSubmissionWindow';
  };
}

export interface DeleteAllSections {
  type: typeof DELETE_ALL_SECTIONS;
  payload: {
    componentId: Component['_id'];
  };
}

export interface DeleteAllComponents {
  type: typeof DELETE_ALL_COMPONENTS;
}

export interface SetIsReportBeingGenerated {
  type: typeof SET_IS_REPORT_BEING_GENERATED;
  payload: {
    isReportBeingGenerated: boolean;
  };
}

export interface SetError {
  type: typeof SET_ERROR;
}

export type ComponentsActionTypes =
  | SetComponents
  | SetIsLoading
  | GetComponents
  | SetComponent
  | SetComponentSection
  | SetFetchedComponent
  | AddDigitallyReceived
  | SetError
  | SetIsLoading
  | DeleteSeriesSubmissionWindow
  | DeleteSection
  | DeleteComponentSection
  | DeleteComponentSections
  | DeleteAllSections
  | DeleteAllComponents
  | SetIsReportBeingGenerated;
